import Icon, { IconProps } from './Icon';

import DotsVerticalIcon from '../../../assets/icons/dots-vertical.svg?react';

const DotsVertical: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <DotsVerticalIcon />
    </Icon>
  );
};

export default DotsVertical;

